import { CancelOutlined, CheckCircleOutlineOutlined } from '@mui/icons-material';
import BalanceIcon from '@mui/icons-material/Balance';
import ViewListIcon from '@mui/icons-material/ViewList';
import { Box, Card, CardContent, Chip, Dialog, DialogContent, DialogTitle, Grid, Paper, Skeleton, Stack, Tab, Tooltip, Typography, useMediaQuery } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import React, { useCallback, useEffect, useMemo, useReducer, useRef, useState } from 'react';
import { useLocation, useNavigate, useSearchParams } from 'react-router-dom';
import { AdvantageCycleModel } from '../AppGrid/AdvantageCycleDetailsTable';
import { BICIResultTableModel } from '../AppGrid/BICIResultTable';
import { CabinetModel } from '../AppGrid/CabinetCycleDetailsTable';
import { model as CycleModel } from '../AppGrid/CycleTable';
import { DashBordCIForm } from '../AppGrid/DashBoardCIResult';
import { EndoWasherTable } from '../AppGrid/EndoWasherCycleDetialsTable';
import { IncubatorTable } from '../AppGrid/IncubatorCycleTable';
import { LCSCIResultModel } from '../AppGrid/LCSCILotNumberTable';
import { LequidChemicalTable } from '../AppGrid/LiquidChemicalCycleDetailsTable';
import { NonSterisSteamModel } from '../AppGrid/NonSteamDetailsTable';
import { RelianceTable } from '../AppGrid/RelianceCabinetCycleDetailsTable';
import { VhpSterilizerTable } from '../AppGrid/SterilizerCycleTable';
import { SterilizerPendingBiModel } from '../AppGrid/SterilizerPendingBITable';
import { StreamSterilizerTabel } from '../AppGrid/StreamSterilizerCycleDetailsTable';
import { StsResultModel } from '../AppGrid/StsResultTabel';
import { UltrasonicTable } from '../AppGrid/UltrasonicCycleDetailsTable';
import { OperatorNameModel } from '../AppGrid/UpdateOperatorTable';
import { WasherCiResultTable } from '../AppGrid/WasherCIResultTable';
import { WasherTable } from '../AppGrid/WasherCycleDetailsTable';
import strings from '../Globalization/index';
import { StatisticsPieChart } from '../components/common/DashboardComponents/Statistics';
import { CustomMuiTabs } from '../components/common/Tabs';
import consts from '../consts';
import { useBreadcrumbs } from '../contexts/Breadcrumbs';
import connectionService from '../services/Connection';
import util from '../util/index';
import AtlasCycleGrid from '../AppGrid/AtlasCycleGrid';

const BiCiResultForm = BICIResultTableModel.createFormDialog()
const { ConnectivityType } = consts;
const { CSVConvert, Proconnect, Kodiak, CATSync, AMSCO600EU, Washer } = ConnectivityType;
const validateWasher = [CSVConvert, Proconnect, Kodiak, CATSync, Washer];
const validateSteamStrilizer = [Proconnect, Kodiak, AMSCO600EU, CATSync];
const validateVhpStrilizer = [Proconnect, Kodiak, CATSync];
const taskStatus = consts.TaskStatus;

const TabPanel = ({ children, value, currentValue, sx = {}, ...other }) => {
	return (
		<div role="tabpanel" hidden={value !== currentValue} {...other}>
			{value === currentValue && (
				<Box sx={sx}>
					{children}
				</Box>
			)}
		</div>
	);
};
const CyclesGridTable = CycleModel.createGridBase();
const AdvantageGridTable = AdvantageCycleModel.createGridBase();
const IncubatorCycleTable = IncubatorTable.createGridBase();

const CabinetGridTable = CabinetModel.createGridBase();
const RelianceGridTable = RelianceTable.createGridBase();
const EndoWasherGridTable = EndoWasherTable.createGridBase();
const UtrasonicGridTable = UltrasonicTable.createGridBase();
const SterilizerPendingBITabel = SterilizerPendingBiModel.createGridBase();
const LequidChemicalGridTable = LequidChemicalTable.createGridBase();
const SteamStrilizerTabel = StreamSterilizerTabel.createGridBase();
const WasherGridTable = WasherTable.createGridBase();
const StrilizerTable = VhpSterilizerTable.createGridBase();
const OperatorForm = OperatorNameModel.createFormDialog();
const CIResultForm = DashBordCIForm.createFormDialog();
const StsResultForm = StsResultModel.createFormDialog();
const LCSCIResultForm = LCSCIResultModel.createFormDialog();
const WasherCiResultForm = WasherCiResultTable.createFormDialog();
const NonSterisSteamGrid = NonSterisSteamModel.createGridBase();
const biciCombo = [{ "type": "BILotNumber", "loaded": true }, { "type": "CILotNumber", "loaded": true }];
const fieldVlidation = ['STSResultIcon', 'LCSCIResultIcon', 'WasherCIResultIcon']
const { RelianceCabinet, EndoCabinet, Robot } = consts.EquipmentFamilyID;
const { AER, ENDOWASHER, ULTRASONIC, INCUBATOR, WASHER, LIQUIDCHEMICAL, STEAMSTERILIZER, VHPSTERILIZER } = consts.EquipmentType;
const { NONSTERISSTEAM, NONSTERISHP } = consts.EquipmentFamilyType;
const PopupDialog = ({ isLiquidChemical, equipmentId, id, open, row, onSave, onClose, field, dialogTilte }) => {
	const [searchParams] = useSearchParams();

	const [activeRecord, setActiveRecord] = useState({ record: {}, combos: {} });
	const [loading, setLoading] = useState(false);
	equipmentId = searchParams.get('id');
	const api = connectionService.IncubatorCycle;
	const recordId = row?.IncubatorCycleId || 0
	const fetchActiveRecord = useCallback(async () => {
		if (field !== 'OperatorName') {
			const formData = new FormData();
			formData.append('id', recordId);
			formData.append('sterilizerId', equipmentId);
			formData.append('BIResult', row?.BIResult || 0);
			formData.append('ExpiryDate', row?.ExpiryDate);
			formData.append('BILotNumberId', row?.BILotNumberId);
			formData.append('CIResult', row?.CIResult || 0);
			formData.append('CILotNumberId', row?.CILotNumberId || 0);
			formData.append('action', 'load')
			formData.append('comboTypes', JSON.stringify(biciCombo))
			formData.append('sterilizerCycleId', id);

			try {
				const response = await fetch(api, {
					method: 'POST',
					body: formData,
				})
				const { data, combos = {}, success } = await response.json();
				if (data) {
					const { BILotNumber = [], CILotNumber = [] } = combos;
					const ciLotNumberData = CILotNumber?.find((data) => (data.DisplayValue === row?.CILotNumber));
					const biLotNumberData = BILotNumber?.find((data) => data.DisplayValue === row?.BILotNumber);
					const CILotNumberId = ciLotNumberData ? ciLotNumberData?.DisplayValue : row?.CILotNumberId;
					const BILotNumberId = biLotNumberData ? biLotNumberData?.DisplayValue : row?.BILotNumberId;
					setActiveRecord({
						id: data.id,
						record: { ...data, BILotNumberId, CILotNumberId },
						combos: combos,
						CIResult: row.CIResult || 0,
						BIResult: row.BIResult || 0,
					})
					setLoading(false);
				}
			} catch (error) {
				console.error('Error creating record:', error);
			}
		}
		else {
			setActiveRecord({
				record: { OperatorName: row.OperatorName },
			})
		}
	}, [id]);

	const hadleSubmit = useCallback(async (params) => {
		//once success
		const formData = new FormData();
		const isOperator = params.hasOwnProperty('OperatorName');
		const api = isOperator ? connectionService.CycleList : connectionService.IncubatorCycle;
		const minTemp = row.MinTemp || 0;
		const maxTemp = row.MaxTemp || 0;
		if (isOperator) {
			formData.append('cycleId', row.CycleId);
			formData.append('action', 'otherAction');
			formData.append('operatorName', params.OperatorName)
			formData.append('otherAction', 'UpdateOperator');
		} else {
			formData.append('BILotNumberId', params.BILotNumberId || 0);
			formData.append('CILotNumberId', params.CILotNumberId || 0);
			formData.append('BIResult', params?.BIResult || row?.BIResult);
			formData.append('CIResult', params?.CIResult || row?.CIResult);
			formData.append('SterilizerId', equipmentId);
			formData.append('SterilizerCycleId', id);
			formData.append('ExpiryDate', params.ExpiryDate || '');
			formData.append('id', recordId);
			formData.append('MinTemp', minTemp);
			formData.append('MaxTemp', maxTemp);
			formData.append('action', 'save');
			formData.append('comboTypes', JSON.stringify(biciCombo))
		}
		try {
			const response = await fetch(api, {
				method: 'POST',
				body: formData,
			})
			const { success, err } = await response.json();
			if (!success) {
				util.showError(
					strings[err],
					strings.Error,
					'error'
				)
			}
			setLoading(false);

		} catch (error) {
			console.error('Error creating record:', error);
		}
		onClose();
		if (typeof onSave === 'function') {
			onSave(params)
		}
	}, [id, onSave])

	const fetchSTsResult = useCallback(async () => {
		const formData = new FormData();
		const api = field === 'WasherCIResultIcon' ? connectionService.CycleList : connectionService.EndoSystemCycleList;
		if (field === 'WasherCIResultIcon') {
			formData.append('id', row?.id);
			formData.append('WasherCIResult', row?.WasherCIResult || 0);
			formData.append('WasherCILotNumberId', row?.WasherCILotNumberId);
			formData.append('action', 'load')
			formData.append('comboTypes', JSON.stringify([{ "type": "CleaningIndicator", "loaded": true }]))
		} else {
			formData.append('id', row?.EndoSystemCycleId);
			formData.append('STSResult', row?.STSResult || 0);
			formData.append('STSLotNumber', row?.STSLotNumber);
			formData.append('LCSCIResult', row?.LCSCIResult || 0);
			formData.append('LCSCILotNumber', row?.LCSCILotNumber);
			formData.append('action', 'load')
			formData.append('comboTypes', JSON.stringify([{ "type": "CleaningIndicator", "loaded": true }]))
		}
		try {
			const response = await fetch(api, {
				method: 'POST',
				body: formData,
			})
			const { data, combos, success } = await response.json();
			if (data) {
				setActiveRecord({
					id: data.id,
					record: data,
					combos: combos,
					STSResult: row?.STSResult,
					LCSCIResult: row?.LCSCIResult
				})
				setLoading(false);
			}
		} catch (error) {
			console.error('Error creating record:', error);
		}

	}, [id]);

	useEffect(() => {
		if (open && !fieldVlidation.includes(field)) {
			fetchActiveRecord()
		} else if (open && fieldVlidation.includes(field)) {
			fetchSTsResult()
		}
	}, [open, id])
	const hadleSIbISubmit = useCallback(async (params) => {
		const stsResult = params.STSResult ? params.STSResult : activeRecord.record.STSResult;
		const lcsciResult = params.LCSCIResult ? params.LCSCIResult : activeRecord.record.LCSCIResult;
		const stsLotNumber = params.STSLotNumber ? params.STSLotNumber : activeRecord.record.STSLotNumber;
		const api = field === 'WasherCIResultIcon' ? connectionService.CycleList : connectionService.EndoSystemCycleList;
		const newId = isLiquidChemical ? row.EndoSystemCycleId : id;
		const formData = new FormData();
		if (field === 'LCSCIResultIcon') {
			formData.append('LCSCILotNumber', params.LCSCILotNumber);
		}
		if (field === 'STSResultIcon') {
			formData.append('STSLotNumber', stsLotNumber);
		}
		if (field === 'WasherCIResultIcon') {
			formData.append('WasherCILotNumberId', params.WasherCILotNumber || 0);
			formData.append('WasherCIResult', params.WasherCIResultIcon);
		}
		if (field === 'STSResultIcon' || field === 'LCSCIResultIcon') {
			formData.append('STSResult', stsResult);
			formData.append('LCSCIResult', lcsciResult);
		}
		formData.append('id', newId);
		formData.append('action', 'save');
		formData.append('comboTypes', JSON.stringify([{ "type": "CleaningIndicator", "loaded": true }]))
		fetch(api, {
			method: 'POST',
			body: formData,
		}).then(res => res.json())
			.then(({ success }) => {
				if (success) {
					if (typeof onSave === 'function') {
						onSave(params);
					}
					setLoading(false);
					onClose();
				}
			})
			.catch((err) => {
				//Show error
			});

	}, [id, onSave])

	return (
		<Dialog open={open} onClose={onClose} fullWidth={true} maxWidth='md' >
			<DialogTitle>{dialogTilte}</DialogTitle>
			<DialogContent>
				{field === 'BIResult' && <BiCiResultForm setActiveRecord={setActiveRecord} loading={loading} hideCancel hideSubmit activeRecord={activeRecord} containerProps={{ elevation: 0 }} onSubmit={hadleSubmit} formActions={[{ text: strings.Save, type: 'submit', color: 'success', variant: 'contained' }, { text: strings.Cancel, type: 'button', color: 'warning', onClick: onClose, variant: 'contained' }]} />}
				{field === 'OperatorName' && <OperatorForm setActiveRecord={setActiveRecord} loading={loading} hideCancel hideSubmit activeRecord={activeRecord} containerProps={{ elevation: 0 }} onSubmit={hadleSubmit} formActions={[{ text: strings.Update, type: 'submit', color: 'success', variant: 'contained' }, { text: strings.Cancel, type: 'button', color: 'warning', onClick: onClose, variant: 'contained' }]} />}
				{field === 'CIResult' && <CIResultForm setActiveRecord={setActiveRecord} loading={loading} hideCancel hideSubmit activeRecord={activeRecord} containerProps={{ elevation: 0 }} onSubmit={hadleSubmit} formActions={[{ text: strings.Save, type: 'submit', color: 'success', variant: 'contained' }, { text: strings.Cancel, type: 'button', color: 'warning', onClick: onClose, variant: 'contained' }]} />}
				{field === 'STSResultIcon' && <StsResultForm setActiveRecord={setActiveRecord} loading={loading} hideCancel hideSubmit activeRecord={activeRecord} containerProps={{ elevation: 0 }} onSubmit={hadleSIbISubmit} formActions={[{ text: strings.Save, type: 'submit', color: 'success', variant: 'contained' }, { text: strings.Cancel, type: 'button', color: 'warning', onClick: onClose, variant: 'contained' }]} />}
				{field === 'LCSCIResultIcon' && <LCSCIResultForm setActiveRecord={setActiveRecord} loading={loading} hideCancel hideSubmit activeRecord={activeRecord} containerProps={{ elevation: 0 }} onSubmit={hadleSIbISubmit} formActions={[{ text: strings.Save, type: 'submit', color: 'success', variant: 'contained' }, { text: strings.Cancel, type: 'button', color: 'warning', onClick: onClose, variant: 'contained' }]} />}
				{field === 'WasherCIResultIcon' && <WasherCiResultForm setActiveRecord={setActiveRecord} loading={loading} hideCancel hideSubmit activeRecord={activeRecord} containerProps={{ elevation: 0 }} onSubmit={hadleSIbISubmit} formActions={[{ text: strings.Save, type: 'submit', color: 'success', variant: 'contained' }, { text: strings.Cancel, type: 'button', color: 'warning', onClick: onClose, variant: 'contained' }]} />}
			</DialogContent>
		</Dialog>
	)
}

const TabsComponent = ({ equipmentTypeId, propsData, modalityId, state, setState, isFromEquipmentDetail, equipmentType, location, parentFilters, gridRef, EquipmentId }) => {
	const [value, setValue] = React.useState('1');
	const theme = useTheme()
	const navigate = useNavigate();
	const { data = {} } = state?.json || {};
	const { EquipmentFamilyId = '', ConnectivityType = '', EquipmentTypeId = '', ModelName } = data || {};
	const isRelianceCabinet =
		consts.regex.relianceCabinetReg.test(ModelName),
		isEndoCabinet = EndoCabinet === EquipmentFamilyId,
		isEndoWasher = ENDOWASHER === (EquipmentTypeId),
		isUltrasonic = ULTRASONIC === (EquipmentTypeId),
		isIncubator = INCUBATOR === (EquipmentTypeId),
		isWasher = validateWasher.includes(ConnectivityType || Washer) && (EquipmentTypeId) === Washer,
		isLiquidChemical = LIQUIDCHEMICAL === (EquipmentTypeId),
		isSteamStrilizer = ConnectivityType ? validateSteamStrilizer.includes(ConnectivityType) && (EquipmentTypeId) === STEAMSTERILIZER : (EquipmentTypeId) === STEAMSTERILIZER,
		isVhpStrilizer = ConnectivityType ? validateVhpStrilizer.includes(ConnectivityType) && (EquipmentTypeId) === VHPSTERILIZER : (EquipmentTypeId) === VHPSTERILIZER,
		isNonSterisSteam = (NONSTERISSTEAM === EquipmentFamilyId || NONSTERISHP === EquipmentFamilyId) && ![STEAMSTERILIZER, VHPSTERILIZER].includes(EquipmentTypeId),
		isAdvantage = AER === (EquipmentTypeId),
		isRobot = Robot === (EquipmentFamilyId);
	const filterProperty = isIncubator ? 'EquipmentId' : 'SterilizerId';
	const incubatorFilter = [{ "operator": "$eq", "value": 0, "property": "IsAcknowledge", "type": "numeric" },
	{ "operator": "$eq", "value": state.id, "property": filterProperty, "type": "numeric" }]
	const handleChange = (event, newValue) => {
		setValue(newValue);
	};

	const handleOnSetActiveRecord = ({ record, id, location }, options) => {
		const {
			AdvantageCycleId = '',
			AttachmentCount,
			EquipmentFamilyId,
			EndoSystemCycleId,
			SterilizerCycleId,
			SterilizerId
		} = record || {};
		let  { EquipmentTypeId = isIncubator ? consts.EquipmentType.INCUBATOR : '' } = record || {};
		if (EquipmentFamilyId === consts.EquipmentFamilyType.ENSPIRE3000) {
			EquipmentTypeId = EquipmentFamilyId;
		}

		switch (EquipmentTypeId) {
			case consts.EquipmentType.AER:
				navigate(`/advantagecycleinfo?id=${AdvantageCycleId}&equipmentFamilyId=${EquipmentFamilyId}&attachmentCount=${AttachmentCount}`);
				break;
			case consts.EquipmentType.CABINET:
				const isEndoCabinet = EquipmentTypeId === consts.EquipmentType.CABINET;
				navigate(
					`/endosystemcycleinfo?attachmentCount=${AttachmentCount}&equipmentFamilyId=${EquipmentFamilyId}&id=${EndoSystemCycleId}&isEndoCabinet=${isEndoCabinet}`
				);
				break;
			case consts.EquipmentType.LIQUIDCHEMICAL:
				navigate(`/endosystemcycleinfo?attachmentCount=${AttachmentCount}&id=${EndoSystemCycleId}`);
				break;
			case consts.EquipmentType.STERILIZER:
			case consts.EquipmentType.STEAMSTERILIZER:
			case consts.EquipmentType.VHPSTERILIZER:
				navigate(
					`/sterilizercycleinfo?id=${SterilizerCycleId}&sterilizerId=${SterilizerId}&attachmentCount=${AttachmentCount}`,
					{
						state: record
					}
				);
				break;
			case consts.EquipmentType.INCUBATOR:
				navigate(`/incubatorcycledetailform?id=${record?.IncubatorCycleDetailId || 0}&attachmentCount=${record?.AttachmentCount || 0}&cycleId=${record?.CycleId || 0}&incubatorCycleId=${record?.IncubatorCycleId || 0}&isError=${record?.BIResult === consts.BIResult.Error}&isFromCycle=${false}&EquipmentId=${EquipmentId}&returnTo=${encodeURIComponent(`/equipmentinfo${location.search}`)}`, { state: { ...location.state, previousPath: location.pathname } });
				break;
			case consts.EquipmentFamilyType.ENSPIRE3000:
				navigate(`/enspirecycleinfo?id=${EndoSystemCycleId}&equipmentFamilyId=${EquipmentFamilyId}&equipmentId=${record.EquipmentId}&attachmentCount=${AttachmentCount}`);
				break;
			default:
				navigate(`/cycleinfo?id=${id}`);
				break;
		}

	};
	return (<Box>
			<Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
				<CustomMuiTabs onChange={handleChange} indicatorColor={theme.palette.primary.light}
					value={value}>
					<Tab label={strings.List} value="1" variant="small" iconPosition="start" icon={<ViewListIcon />} />
					{(isVhpStrilizer || isSteamStrilizer || isNonSterisSteam || isIncubator) && (<Tab label={strings.PendingBI} value="2" variant="small" iconPosition="start" icon={<BalanceIcon />} />)}
				</CustomMuiTabs>
			</Box>
			<TabPanel value="1" currentValue={value} sx={{ padding: 0 }}>
				<Box>
					{
						isNonSterisSteam && (
							<NonSterisSteamGrid
								disablePreferences
								isChild={true}
								title={strings.CycleList}
								propsData={propsData}
								disableLoadPref={!!modalityId}
								baseFilters={[{ column: 'EquipmentId', value: state.id, type: 'int' }]}
								onSelection={(id, { row, field }) => {
									if (field === 'BIResult' || field === 'OperatorName' || field === 'CIResult') {
										const title = field === 'BIResult' ? strings.BIResult :
											field === 'OperatorName' ? strings.UpdateOperator : field === 'CIResult' ? strings.CIResult : '';
										setState({ selectedId: id, selectedRow: row, field, dialogTilte: title });
									}
								}}
								isFromEquipmentDetail={isFromEquipmentDetail}
								equipmentType={equipmentType}
								location={location}
								ref={gridRef}
								onOpenForm={handleOnSetActiveRecord}
							/>)
					}
					{
						isVhpStrilizer && (
							<StrilizerTable
								disablePreferences
								isChild={true}
								title={strings.CycleList}
								propsData={propsData}
								disableLoadPref={!!modalityId}
								baseFilters={[{ column: 'EquipmentId', value: state.id, type: 'int' }]}
								onSelection={(id, { row, field }) => {
									if (field === 'BIResult' || field === 'OperatorName' || field === 'CIResult') {
										const title = field === 'BIResult' ? strings.BIResult :
											field === 'OperatorName' ? strings.UpdateOperator : field === 'CIResult' ? strings.CIResult : '';
										setState({ selectedId: id, selectedRow: row, field, dialogTilte: title });
									}
								}}
								isFromEquipmentDetail={isFromEquipmentDetail}
								equipmentType={equipmentType}
								location={location}
								parentFilters={{ filter: [{ "operator": "$eq", "value": data.SerialNumber, "property": "SerialNumber", "type": "string" }], asArray: 0 }}
								// parentFilters={parentFilters}
								ref={gridRef}
								onOpenForm={handleOnSetActiveRecord}
							/>)
					}
					{
						isSteamStrilizer && (
							<SteamStrilizerTabel
								disablePreferences
								isChild={true}
								title={strings.CycleList}
								propsData={propsData}
								disableLoadPref={!!modalityId}
								baseFilters={[{ column: 'EquipmentId', value: state.id, type: 'int' }]}
								onSelection={(id, { row, field }) => {
									if (field === 'BIResult' || field === 'OperatorName' || field === 'CIResult') {
										const title = field === 'BIResult' ? strings.BIResult :
											field === 'OperatorName' ? strings.UpdateOperator : field === 'CIResult' ? strings.CIResult : '';
										setState({ selectedId: id, selectedRow: row, field, dialogTilte: title });
									}
								}}
								isFromEquipmentDetail={isFromEquipmentDetail}
								equipmentType={equipmentType}
								location={location}
								parentFilters={{ filter: [{ "operator": "$eq", "value": data.SerialNumber, "property": "SerialNumber", "type": "string" }], asArray: 0 }}
								ref={gridRef}
								onOpenForm={handleOnSetActiveRecord}
							/>
						)
					}
					{
						isAdvantage && (
							<AdvantageGridTable
								disablePreferences
								isChild={true}
								title={strings.CycleList}
								propsData={propsData}
								disableLoadPref={!!modalityId}
								baseFilters={[{ column: 'EquipmentId', value: state.id, type: 'int' }]}
								isFromEquipmentDetail={isFromEquipmentDetail}
								equipmentType={equipmentType}
								location={location}
								parentFilters={{ filter: [...parentFilters.filter, { operator: '$not', property: 'EventType', value: '0', type: 'string' }] }}
								ref={gridRef}
								onOpenForm={handleOnSetActiveRecord}
							/>
						)
					}
					{
						isRelianceCabinet && (
							<RelianceGridTable
								disablePreferences
								isChild={true}
								title={strings.CycleList}
								propsData={propsData}
								disableLoadPref={!!modalityId}
								baseFilters={[{ column: 'EquipmentId', value: state.id, type: 'int' }]}
								isFromEquipmentDetail={isFromEquipmentDetail}
								equipmentType={equipmentType}
								location={location}
								parentFilters={parentFilters}
								ref={gridRef}
								onOpenForm={handleOnSetActiveRecord}
							/>
						)
					}
					{
						isEndoCabinet && (<CabinetGridTable
							disablePreferences
							isChild={true}
							title={strings.CycleList}
							propsData={propsData}
							disableLoadPref={!!modalityId}
							baseFilters={[{ column: 'EquipmentId', value: state.id, type: 'int' }]}
							isFromEquipmentDetail={isFromEquipmentDetail}
							equipmentType={equipmentType}
							location={location}
							parentFilters={parentFilters}
							ref={gridRef}
							onOpenForm={handleOnSetActiveRecord}
						/>)
					}
					{
						isEndoWasher && (<EndoWasherGridTable
							disablePreferences
							isChild={true}
							title={strings.CycleList}
							propsData={propsData}
							disableLoadPref={!!modalityId}
							baseFilters={[{ column: 'EquipmentId', value: state.id, type: 'int' }]}
							isFromEquipmentDetail={isFromEquipmentDetail}
							equipmentType={equipmentType}
							location={location}
							parentFilters={parentFilters}
							ref={gridRef}
							onOpenForm={handleOnSetActiveRecord}
						/>)
					}
					{
						isUltrasonic && (<UtrasonicGridTable
							disablePreferences
							isChild={true}
							title={strings.CycleList}
							propsData={propsData}
							disableLoadPref={!!modalityId}
							baseFilters={[{ column: 'EquipmentId', value: state.id, type: 'int' }]}
							isFromEquipmentDetail={isFromEquipmentDetail}
							equipmentType={equipmentType}
							location={location}
							parentFilters={parentFilters}
							ref={gridRef}
							onOpenForm={handleOnSetActiveRecord}
						/>)
					}
					{
						isWasher && (<WasherGridTable
							disablePreferences
							isChild={true}
							title={strings.CycleList}
							propsData={propsData}
							disableLoadPref={!!modalityId}
							baseFilters={[{ column: 'EquipmentId', value: state.id, type: 'int' }]}
							onSelection={(id, { row, field }) => {
								if (field === 'WasherCIResultIcon' && row?.ConnectivityTypeId === Proconnect) {
									const title = strings.CIResult;
									setState({ selectedId: id, selectedRow: row, field, dialogTilte: title });
								}
							}}
							isFromEquipmentDetail={isFromEquipmentDetail}
							equipmentType={equipmentType}
							location={location}
							parentFilters={parentFilters}
							ref={gridRef}
							onOpenForm={handleOnSetActiveRecord}

						/>)
					}
					{
						isLiquidChemical && (
							<LequidChemicalGridTable
								disablePreferences
								isChild={true}
								title={strings.CycleList}
								propsData={propsData}
								disableLoadPref={!!modalityId}
								baseFilters={[{ column: 'EquipmentId', value: state.id, type: 'int' }]}
								isFromEquipmentDetail={isFromEquipmentDetail}
								equipmentType={equipmentType}
								location={location}
								parentFilters={parentFilters}
								ref={gridRef}
								onOpenForm={handleOnSetActiveRecord}
							/>
						)
					}
					{
						isIncubator && (
							<IncubatorCycleTable
								disablePreferences
								isChild={true}
								propsData={propsData}
								disableLoadPref={!!modalityId}
								isFromEquipmentDetail={isFromEquipmentDetail}
								equipmentType={equipmentType}
								location={location}
								parentFilters={{ filter: [{ "operator": "$eq", "value": state.id, "property": "IncubatorId", "type": "string" }], asArray: 0 }}
								ref={gridRef}
								onOpenForm={handleOnSetActiveRecord}

							/>
						)
					}
					{
						isRobot && (
							<AtlasCycleGrid
								disablePreferences
								ref={gridRef}
							/>
						)
					}
					{
						<PopupDialog
							field={state.field}
							equipmentId={equipmentTypeId}
							id={state.selectedId}
							open={!!state.selectedId}
							onClose={() => setState({ selectedId: null, selectedRow: null, id: null })}
							onSave={() => {
								if (gridRef.current) {
									gridRef.current.refresh()
								}
							}}
							row={state.selectedRow}
							dialogTilte={state.dialogTilte}
							isLiquidChemical={isLiquidChemical}
						/>
					}
				</Box>
			</TabPanel>
			{(isVhpStrilizer || isSteamStrilizer || isNonSterisSteam || isIncubator) && (
				<TabPanel value="2" currentValue={value} sx={{ padding: 0 }}>
					<SterilizerPendingBITabel
						parentFilters={{ filter: incubatorFilter, asArray: 0 }}
						disablePreferences
						isChild={true}
						propsData={propsData}
						disableLoadPref={!!modalityId}
						isFromEquipmentDetail={isFromEquipmentDetail}
						equipmentType={equipmentType}
						location={location}
						ref={gridRef}
						onOpenForm={handleOnSetActiveRecord}
					/>
				</TabPanel>
			)
			}
	</Box>)
}
const EquipmentInfo = ({ router, searchParam, params, ...props }) => {
	const gridRef = useRef();
	const [searchParams] = useSearchParams();
	const [state, setState] = useReducer(
		(prev, next) => (typeof next === 'function' ? { ...prev, ...next(prev) } : { ...prev, ...next }),
		{
			id: 0,
			loading: true,
			isLog: true,
			json: { data: {}, comboData: {} },
			docTitle: strings.PageHeader + ' | ' + strings.CycleList,
			cycleTableFilters: null,
			advanceSearch: '',
			updateCharts: false,
			isSterilizer: false,
			activeTab: 'List',
			row: null,
			selectedId: null,
			field: '',
			dialogTilte: ''
		}
	);
	const theme = useTheme();
	const navigate = useNavigate();
	const location = useLocation();
	const [, setBreadcrumbs] = useBreadcrumbs();
	const screen = useMediaQuery(theme.breakpoints.between('sm', 'md'));
	const is1024x768 = useMediaQuery('(max-width: 1024px) and (max-height: 768px)');
	const data = state.json.data;
	const propsData = searchParams.get('propsData') ? JSON.parse(searchParam.get('propsData')) : {};
	let lastConnected = null;
	const taskDue = data?.TaskDue || 0;
	const taskComplete = data?.TaskComplete || 0;
	const taskClosed = data?.TaskClosed || 0;
	const taskPastDue = data?.TaskPastDue || 0;
	const totalTask = taskDue + taskComplete + taskClosed + taskPastDue;
	const modalityId = consts.isNodeServer ? (propsData.modalityId || propsData.id || 0) : Number(propsData.modalityId || propsData.id || 0);
	if (data && data?.LastConnection !== null) {
		lastConnected = (((new Date() - data.LastConnection) / 1000) / 60) / 60;
	}
	let clientId = searchParams.get('clientId') ? searchParams.get('clientId') : 0;
	if (util.localData.loginData) {
		clientId = util.localData.loginData.tags.ClientId;
	}
	const isFromEquipmentDetail = propsData.isFromEquipmentDetail ? propsData.isFromEquipmentDetail : false;
	const equipmentType = searchParams.get('equipmentType') ? searchParams.get('equipmentType') : '';
	const isDryingCabinet = equipmentType && (equipmentType.toUpperCase() === consts.EquipmentTypeName.DRYINGCABINET || equipmentType.toUpperCase() === consts.EquipmentTypeName.ENODCABINET) ? true : false;
	const EquipmentId = searchParams.get('id');
	const equipmentTypeId = searchParams.get('equipmentTypeId') || searchParams.get('EquipmentTypeId');
	const parentFilters = useMemo(() => {
		let filters = [{ "operator": "$eq", "value": EquipmentId, "property": "EquipmentId", "type": "numeric" }]
		return { filter: filters }
	}, [EquipmentId]);

	const bindActionInfo = (action) => {
		let params = {};
		params.id = searchParams.get('id') || '0';
		params.isSterilizer = searchParams.get('isSterilizer') === "true";
		params.isIncubator = searchParams.get('isIncubator') === "true";
		params.isFromEquipmentDetail = searchParams.get('isFromEquipmentDetail') === "true";
		params.equipmentType = searchParams.get('equipmentType');

		setState({
			id: params.id,
			isSterilizer: JSON.parse(params.isSterilizer),
			isIncubator: JSON.parse(params.isIncubator),
			isFromEquipmentDetail: JSON.parse(params.isFromEquipmentDetail),
			equipmentType: params.equipmentType
		});

		params.action = action;

		if (props.comboTypes) {
			let comboTypes = [];
			for (let i = 0, len = props.comboTypes.length; i < len; i++) {
				comboTypes.push({ "type": props.comboTypes[i], "loaded": true });
			}
			if (Array.isArray(comboTypes)) {
				params.comboTypes = JSON.stringify(comboTypes);
			}
		}
		return params;
	};

	const handleAction = (params) => {
		setState({ loading: true });
		let fetchData = {}
		const formData = new FormData();
		formData.append('id', params.id);
		formData.append('isSterilizer', params.isSterilizer);
		formData.append('isIncubator', params.isIncubator);
		formData.append('isFromEquipmentDetail', params.isFromEquipmentDetail);
		formData.append('equipmentType', params.equipmentType);
		formData.append('action', params.action);

		fetch(connectionService.DashBoardEquipment, { method: 'POST', body: formData })
			.then((response) => response.json())
			.then((data) => {
				fetchData = data
				setBreadcrumbs({
					breadcrumbs: [
						{ text: `${strings.EquipmentInfo}` },
					], subbreadcrumbs: [
						{ text: `${strings.Dashboard}`, to: '/dashboard' },
						{ text: `${strings.ModalityDashboard}`, to: '/modalitydashboard' },
						{ text: `${strings.EquipmentInfo} - ${data?.data?.EquipmentName || searchParams.get('name') || ''}` }
					]
				});
				setState({ loading: false, json: data });
			})
			.catch((error) => {
				setState({ loading: false });
			});
		return fetchData;
	};

	useEffect(() => {
		window.scrollTo(0, 0);
		let params = bindActionInfo('load');
		handleAction(params);
	}, [EquipmentId]);

	const handleClick = (taskStatusId, path) => {
		let obj = { disableLoadPref: true, hideTypeFilter: true, equipmentTypeId: 0, taskStatusId: 0 };
		if (taskStatusId) {
			obj.taskStatusId = taskStatusId
		}

		navigate(`/${path}?disableLoadPref=${obj.disableLoadPref}&hideTypeFilter=${obj.hideTypeFilter}&equipmentTypeId=${obj.equipmentTypeId}&taskStatusId=${obj.taskStatusId}`)
	};


	return (
		<Grid container sx={{ paddingTop: theme.spacing(2) }}>
			{state.loading ? (
				<Skeleton width={'100%'} height={theme.mixins.drawer.width} sx={{ transform: 'scale(1, 1)' }} />
			) : (
				<Grid size={12}>
					<Card>
						<CardContent>
							<Grid container spacing={2}>
									<Grid size={{xs: 6, md: 6, lg: 2}} display="flex" justifyContent="space-between">
									{data ? (
										<Box>
											<Box
												component="img"
												src={`${connectionService.PTXImage}/${data.EquipmentImageUrl}?v=${new Date()}`}
												alt="washer"
												sx={{ maxHeight: 88, paddingLeft: 4, marginBottom: '1em' }}
											/>
											{data?.EquipmentName ? (
												<Box textAlign={'center'} paddingLeft={4} >
													<Typography variant="body1" component="span" sx={{ display: 'block', maxWidth: '100%', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'normal' }}>
														{' '}
														{data?.EquipmentName}
													</Typography>
													<Typography variant="body1" component="span">
														{' '}
														{data?.MachineNumber}
													</Typography>
												</Box>
											) : (
												''
											)}
										</Box>
									) : null}
								</Grid>

									<Grid size={{ xs: 6, md: 6, lg: 3}} display="flex" justifyContent="space-between">
									<Grid
										container
										sx={{
											'& .keyValueRow': {
												display: 'grid',
												gridTemplateColumns: screen || is1024x768 ? '130px 50px 50px' : '150px 100px 100px',
												'& .keyLabel': { fontWeight: 'bold', width: 'auto' },
												'& .keyValue': { marginLeft: screen || is1024x768 ? '-2em' : '-4em' }
											}
										}}
									>
										<Grid size={{xs: 12, md: 8 }} className="keyValueRow">
											<Typography variant="body1" className="keyLabel">
												{strings.SNo}
											</Typography>
											<Typography variant="body1" component="span">
												{' '}
												:{' '}
											</Typography>
											<Typography variant="body1" className="keyValue">
												{' '}
												{data?.SerialNumber}
											</Typography>
										</Grid>
										<Grid size={{xs: 12, md: 8 }}className="keyValueRow">
											<Typography variant="body1" className="keyLabel">
												{strings.Model}
											</Typography>
											<Typography variant="body1" component="span">
												:
											</Typography>
											<Typography variant="body1" className="keyValue">
												{data?.ModelName}
											</Typography>
										</Grid>

										<Grid size={{xs: 12, md: 8 }} className="keyValueRow">
											<Typography variant="body1" className="keyLabel">
												{strings.EquipmentType}
											</Typography>
											<Typography variant="body1" component="span">
												{' '}
												:{' '}
											</Typography>
											<Typography variant="body1" className="keyValue">
												{' '}
												{data?.EquipmentType}
											</Typography>
										</Grid>

										<Grid size={{xs: 12, md: 8 }} className="keyValueRow">
											<Typography variant="body1" className="keyLabel">
												{strings.Status}
											</Typography>
											<Typography variant="body1" component="span">
												:
											</Typography>
											<Typography variant="body1" className="keyValue">
												{data?.IsActive ? (
													<CheckCircleOutlineOutlined
														sx={{ color: data?.IsActive ? '#357a38' : '#ff1744' }}
														title={strings.ActiveEquipments}
													/>
												) : (
													<CancelOutlined
														sx={{ color: data?.IsActive ? '#357a38' : '#ff1744' }}
														title={strings.InactiveEquipments}
													/>
												)}
											</Typography>
										</Grid>
									</Grid>
								</Grid>
								<Grid size={{xs: 6, md: 6, lg: 4 }}display="flex" sx={{ justifyContent: screen || is1024x768 ? 'space-between' : 'center' }}>
									<Box sx={{ width: 100, textAlign: 'center' }}>
										<Typography variant="h6" component="span">
											{' '}
											{strings.Tasks}{' '}
										</Typography>
										<br />
										<StatisticsPieChart
											data={[
												{ color: '#ff0', value: (taskDue / totalTask) * 100 },
												{
													color: '#ff0000',
													value: totalTask === 0 ? 0 : (taskPastDue / totalTask) * 100
												},
												{
													color: '#92d050',
													value: totalTask === 0 ? 0 : (taskComplete / totalTask) * 100
												},
												{
													color: '#00b050',
													value: totalTask === 0 ? 0 : (taskClosed / totalTask) * 100
												}
											]}
											total={totalTask}
											label={strings.Tasks}
										/>
									</Box>
								</Grid>

								<Grid size={{xs: 6, md: 6, lg: 3 }} display="flex" justifyContent="space-between">
									<Stack spacing={1} sx={{ paddingTop: theme.spacing(1) }}>
										<Tooltip
											title={<Typography variant="h6">{strings.DueTasks}</Typography>}
											placement="right-end"
										>
											<Chip
												label={
													<Typography variant="body2" sx={{ fontWeight: 'bold' }}>
														{taskDue} {strings.Due}
													</Typography>
												}
												color="default"
												sx={{
													width: '11.5em',
													cursor: 'pointer',
													color: '#000000',
													backgroundColor: '#ff0',
													display: 'flex',
													justifyContent: 'flex-start',
													'&:hover': { backgroundColor: '#ff0' }
												}}
												onClick={() => handleClick(taskStatus.Due, 'dashboardtasks')}
											/>
										</Tooltip>

										<Tooltip
											title={<Typography variant="h6">{strings.PastDueTasks}</Typography>}
											placement="right-end"
										>
											<Chip
												label={
													<Typography variant="body2" sx={{ fontWeight: 'bold' }}>
														{taskPastDue} {strings.PastDue}
													</Typography>
												}
												color="default"
												sx={{
													width: '11.5em',
													cursor: 'pointer',
													color: '#000000',
													backgroundColor: '#ff0000',
													display: 'flex',
													justifyContent: 'flex-start',
													'&:hover': { backgroundColor: '#ff0000' }
												}}
												onClick={() => handleClick(taskStatus.PastDue, 'dashboardtasks')}
											/>
										</Tooltip>

										<Tooltip
											title={<Typography variant="h6">{strings.CompleteTasks}</Typography>}
											placement="right-end"
										>
											<Chip
												label={
													<Typography variant="body2" sx={{ fontWeight: 'bold' }}>
														{taskComplete} {strings.Complete}{' '}
													</Typography>
												}
												color="default"
												sx={{
													width: '11.5em',
													cursor: 'pointer',
													color: '#000000',
													backgroundColor: '#92d050',
													display: 'flex',
													justifyContent: 'flex-start',
													'&:hover': { backgroundColor: '#92d050' }
												}}
												onClick={() => handleClick(taskStatus.Complete, 'dashboardtasks')}
											/>
										</Tooltip>

										<Tooltip
											title={<Typography variant="h6">{strings.ClosedTasks}</Typography>}
											placement="right-end"
										>
											<Chip
												label={
													<Typography variant="body2" sx={{ fontWeight: 'bold' }}>
														{taskClosed} {strings.ClosedNoAction}{' '}
													</Typography>
												}
												color="default"
												sx={{
													width: '11.5em',
													cursor: 'pointer',
													color: '#000000',
													backgroundColor: '#00b050',
													display: 'flex',
													justifyContent: 'flex-start',
													'&:hover': { backgroundColor: '#00b050' }
												}}
												onClick={() => handleClick(taskStatus.Closed, 'dashboardtasks')}
											/>
										</Tooltip>
									</Stack>
								</Grid>

							</Grid>
						</CardContent>
					</Card>
				</Grid>
			)}
			<Grid size={12}>
				<Paper>
					<Box padding={2} marginTop={2} color="primary.main">
						<Typography variant="h6">{strings.CycleList}</Typography>
					</Box>
				</Paper>
			</Grid>
			<Grid size={12} className="wrapper wrapper-content">
				<Box className="tabs-container">
					{state.loading ? (
						<Skeleton
							variant="rectangular"
							width={'100%'}
							height={theme.mixins.drawer.width}
							sx={{ transform: 'scale(1, 1)' }}
						/>
					) : (
						<TabsComponent
							equipmentTypeId={equipmentTypeId}
							disablePreferences
							propsData={propsData}
							modalityId={modalityId}
							state={state}
							setState={setState}
							isFromEquipmentDetail={isFromEquipmentDetail}
							equipmentType={equipmentType}
							location={location}
							parentFilters={parentFilters}
							gridRef={gridRef}
							EquipmentId={EquipmentId}
						/>
					)}
				</Box>
			</Grid>
		</Grid>
	);
};


export default EquipmentInfo;
